/* eslint-disable no-script-url, jsx-a11y/no-static-element-interactions */

import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router'

const adminPermissions = ['MANAGE_USERS', 'MANAGE_TENANTS', 'MANAGE_WIDGETS']

const TopMenu = ({
  username,
  onLogoutClick,
  permissions = [],
  profilePicUrl
}) => (
  <div className='top-menu'>
    <ul className='nav navbar-nav pull-right'>
      <li className='dropdown dropdown-user dropdown-dark'>
        <a
          href='javascript:;'
          className='dropdown-toggle'
          data-toggle='dropdown'
          style={{ background: 'transparent' }}
          aria-expanded='false'
        >
          <img
            src={profilePicUrl}
            alt='Profile'
            className='img-circle userIconFix'
          />
          <span className='username username-hide-mobile'>{username}</span>
        </a>
        <ul className='dropdown-menu dropdown-menu-default'>
          <li>
            <Link to='/settings'>
              <i className='fa fa-user' />
              Profile settings
            </Link>
          </li>

          {permissions.some(p => adminPermissions.includes(p)) ? (
            <li>
              <Link to='/admin'>
                <i className='fa fa-cog' />
                Admin
              </Link>
            </li>
          ) : null}
          <li className='divider' />
          <li>
            <a onClick={onLogoutClick}>
              <i className='fa fa-key' />
              Logout
            </a>
          </li>
        </ul>
      </li>
    </ul>
  </div>
)

TopMenu.displayName = 'TopMenu'

TopMenu.propTypes = {
  onLogoutClick: PropTypes.func.isRequired,
  username: PropTypes.string.isRequired,
  profilePicUrl: PropTypes.string.isRequired,
  permissions: PropTypes.array.isRequired
}

export default TopMenu



// WEBPACK FOOTER //
// ./src/components/header/top-menu.js